import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

function formatError(d) {
  if (d == null) return "Login failed. Try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg ?? JSON.stringify(e)).join(" ");
  return String(d);
}

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Signed in");
      nav("/admin");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-sand flex flex-col">
      <div className="container-x py-6">
        <Link to="/" className="overline">← Back to site</Link>
      </div>
      <div className="flex-1 flex items-center">
        <div className="container-x grid md:grid-cols-2 gap-16 py-16 items-center">
          <div>
            <div className="overline text-terracotta">Choose My Hotel admin</div>
            <h1 className="mt-3 font-serif text-5xl md:text-6xl leading-[1.02] tracking-tight">Sign in to manage hotels, guides and subscribers.</h1>
            <p className="mt-5 text-charcoal/70 max-w-md">Editor access only. Use the credentials shared with your team.</p>
          </div>
          <div className="bg-white border border-charcoal/10 p-8 md:p-10">
            <form onSubmit={onSubmit} data-testid="admin-login-form" className="space-y-5">
              <div>
                <label className="overline block mb-2">Email</label>
                <input
                  type="email"
                  required
                  data-testid="admin-email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full bg-sand/50 border border-charcoal/15 px-4 py-3 text-sm focus:outline-none focus:border-terracotta"
                  placeholder="admin@choose-my-hotel.com"
                  autoComplete="email"
                />
              </div>
              <div>
                <label className="overline block mb-2">Password</label>
                <input
                  type="password"
                  required
                  data-testid="admin-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full bg-sand/50 border border-charcoal/15 px-4 py-3 text-sm focus:outline-none focus:border-terracotta"
                  autoComplete="current-password"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                data-testid="admin-login-submit"
                className="btn-primary w-full justify-center disabled:opacity-50"
              >
                {loading ? "Signing in…" : "Sign in"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
